
const zones = state => {
  return state.zones || []
}

const activityZonesList = (state) => {
  return state.activityZoneListData
}

const activityZonesListPagination = (state) => {
  return state.activityZonesPagination
}

const selectedZone = (state) => {
  return state.selectedZone
}

const signalStrengths = state => {
  return state.signalStrengths
}

export default {
  zones,
  activityZonesList,
  activityZonesListPagination,
  selectedZone,
  signalStrengths,
}
